var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopDeliveryCheckSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4854 4.16113C18.7002 3.94653 19.048 3.94641 19.2627 4.16113L21.5967 6.49414C21.8114 6.70887 21.8113 7.05767 21.5967 7.27246L9.69238 19.1758C9.67218 19.196 9.64929 19.2121 9.62695 19.2285L9.40918 19.4473C9.19441 19.662 8.84565 19.662 8.63086 19.4473L2.16113 12.9775C1.94634 12.7628 1.94634 12.414 2.16113 12.1992L4.49414 9.86621C4.70893 9.65142 5.05767 9.65142 5.27246 9.86621L9.02539 13.6191L18.4854 4.16113Z",
    fill: "#007F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopDeliveryCheckSelected);
export default __webpack_public_path__ + "static/media/shopDeliveryCheckSelected.0295f865636d57687db06ea834275b73.svg";
export { ForwardRef as ReactComponent };